export default __webpack_public_path__ + "static/media/google-play-badge.2a864309.svg";